import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownTimerProps = {
  tone?: 'dark' | 'light';
  size?: 'md' | 'lg';
};
export function CountdownTimer({
  tone = 'dark',
  size = 'lg'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Minutes'
  }, {
    value: seconds,
    label: 'Seconds'
  }];
  const boxClass = tone === 'dark' ? 'bg-ink text-white' : 'bg-white text-ink ring-1 ring-white/20';
  const labelClass = tone === 'dark' ? 'text-ink/60' : 'text-white/75';
  const sepClass = tone === 'dark' ? 'text-ink/40' : 'text-white/60';
  const numSize = size === 'lg' ? 'text-3xl sm:text-4xl min-w-[4.25rem] py-2.5' : 'text-2xl min-w-[3.5rem] py-2';
  return <div role="timer" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} className="flex items-start justify-center gap-2 sm:gap-3" data-id="element-87" data-mp="34r09yc5fpvix">
      {units.map((u, i) => <React.Fragment key={u.label} data-id="element-88" data-mp="1bzvm5q26hedc" data-mpi={i}>
          <div className="flex flex-col items-center" data-id="element-89" data-mp="1gzrug1hwrryp">
            <span className={`${boxClass} ${numSize} rounded-xl px-2 text-center font-extrabold tabular-nums leading-none`} data-id="element-90" data-mp="1h0jecf258195">
              {u.value}
            </span>
            <span className={`${labelClass} mt-1.5 text-[11px] font-semibold uppercase tracking-wider`} data-id="element-91" data-mp="1712be5ea01gv">{u.label}</span>
          </div>
          {i < units.length - 1 && <span className={`${sepClass} ${size === 'lg' ? 'text-3xl pt-2' : 'text-2xl pt-1.5'} font-bold`} aria-hidden="true" data-id="element-92" data-mp="1zq9k1x7g27fu">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}